"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isFileAllowed(file, allowed) {
    if (typeof allowed === "string") {
        allowed = allowed.split(",");
    }
    allowed = allowed.map(function (str) { return str.trim(); });
    return allowed.some(function (allow) {
        if (allow.charAt(0) === ".") {
            return file.name && file.name.endsWith(allow.slice(1));
        }
        else if (allow.endsWith("*")) {
            return file.type.startsWith(allow.slice(0, -1));
        }
        else if (allow.startsWith("*")) {
            return file.type.endsWith(allow);
        }
        else {
            return file.type === allow;
        }
    });
}
exports.isFileAllowed = isFileAllowed;
